import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";

/**
 * POST API call for logout (no body)
 * @returns - Logout response
 */
export const logoutApi = async () => {
  const headers = {
    "Content-Type": "application/json",
    "OSD-Module-Name": "dashboard",
    "OSD-Section-Name": "header",
    "OSD-Action-Type": "logout",
  };
  return axios.post(getUrl(ApiType.LOGOUT), undefined, { headers });
};
